import { ArrowUpRight, Clock3 } from "lucide-react";
import { Reveal } from "../site/Reveal";

export default function AuditBanner() {
  return (
    <section data-testid="audit-banner" className="relative bg-[var(--gold)] text-[var(--charcoal)] overflow-hidden">
      <div className="container-luxe py-10 lg:py-12 flex flex-col lg:flex-row lg:items-center gap-6 lg:gap-12">
        <Reveal className="flex items-center gap-4 shrink-0">
          <span className="inline-flex h-11 w-11 items-center justify-center border border-[var(--charcoal)]/30">
            <Clock3 size={20} />
          </span>
          <p className="overline !text-[var(--charcoal)]">Complimentary · Lead Magnet</p>
        </Reveal>
        <Reveal delay={0.1} className="grow">
          <p className="serif text-2xl lg:text-3xl tracking-tight leading-snug">
            The FREE Time-Wealth Audit
          </p>
          <p className="mt-1 text-sm lg:text-base text-[var(--charcoal)]/80 max-w-2xl">
            Seven questions. Three minutes. A precise read on where your hours — and
            your revenue — are quietly leaking.
          </p>
        </Reveal>
        <Reveal delay={0.2} className="shrink-0">
          <a
            href="#audit"
            data-testid="audit-banner-cta"
            className="group inline-flex items-center gap-3 bg-[var(--charcoal)] px-7 py-4 text-sm text-[var(--cream)] hover:bg-[#2a241c] transition-colors duration-400"
          >
            Start the Audit
            <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
